module.exports = __webpack_public_path__ + "img/avatar-default.91ddf0c1.png";